export default __webpack_public_path__ + "static/media/uploadlogo.e2b062fb.svg";